import React, { useContext } from 'react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export const FeaturesContext = /*#__PURE__*/React.createContext({
  isRecentSearchEnabled: false
});
export const FeaturesProvider = ({
  dialogFeatures = {},
  children
}) => {
  let isRecentSearchEnabled = false;
  if (getBooleanFF('platform.search-plex.recent-searches_vynex')) {
    // exists due to - Only call feature flags as part of an expression, don't assign to a variable!
    isRecentSearchEnabled = true;
  }
  const searchFeatures = {
    isRecentSearchEnabled
  };
  return (
    /*#__PURE__*/
    /**
     * Defaults and platfrom feature flag values can be overriden if explicit props are injected. This serves two purposes:
     *
     * 1. Storybook knobs can be provisioned for features that are powered by platfrom feature flags
     *
     * 2. Consumer products like Confluence, Jira can run statsig based experiments, where the Statsig evaluation happens in the product's code
     * but the effect happens inside the code shipped by search platform.
     */
    React.createElement(FeaturesContext.Provider, {
      value: {
        ...searchFeatures,
        ...dialogFeatures
      }
    }, children)
  );
};
export const useFeaturesContext = () => {
  return useContext(FeaturesContext);
};